import type { IEditorVariable } from "@bbj-types/utils";
import { spansToRawVariables, transformRawVariablesToSpans } from "./variableTransformation";

export const toSpanTokens = (value: string, variableList?: IEditorVariable[]): string => {
  // First convert line breaks to HTML paragraphs
  const htmlValue = toHtml(value);
  // Then transform variables to spans
  return transformRawVariablesToSpans(htmlValue, variableList);
};

export const fromEditorHtmlToValue = (editorHtml: string, variableList?: IEditorVariable[]): string => {
  return spansToRawVariables(editorHtml, variableList);
};

export const toHtml = (value: string): string => {
  if (value.includes("<") && value.includes(">")) {
    return value;
  }

  const lines = value.split(/\r?\n/);
  const paragraphs = lines.map((line) => {
    const trimmed = line.trim();
    return trimmed.length > 0 ? `<p>${trimmed}</p>` : "<p></p>";
  });

  return paragraphs.join("");
};
